import * as React from "react";
const SvgIcSortedAsc = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 3.00003L6 13M6 3.00003L9 6.00003M6 3.00003L3 6.00003", stroke: "currentColor", strokeLinecap: "round" }));
export default SvgIcSortedAsc;
